import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "normalize.css/normalize.css";
import "assets/global.scss";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
